import React from 'react';
export function CostComparison() {
  const data = [{
    sin: 'No structure for daily brain training',
    costo: 'Attention gap widens every week'
  }, {
    sin: 'No plan for reducing screen time',
    costo: 'Daily battles that drain everyone'
  }, {
    sin: 'No tools to build focus at home',
    costo: 'Child falls further behind at school'
  }, {
    sin: 'No strategy for emotional regulation',
    costo: 'Meltdowns before every homework session'
  }, {
    sin: 'No progression system',
    costo: 'Child quits every activity before finishing'
  }, {
    sin: 'Feeling helpless as a parent',
    costo: 'The heaviest cost of all'
  }];
  return <section className="bg-white py-16 px-4 border-t border-border" data-id="element-33">
      <div className="max-w-4xl mx-auto" data-id="element-34">
        <h2 className="text-3xl md:text-5xl font-heading font-black text-center text-navy mb-10" data-id="element-35">
          ⚖️ THE REAL COST OF NOT HAVING IT
        </h2>

        <div className="bg-white rounded-3xl overflow-hidden border border-border shadow-md mb-10" data-id="element-36">
          <div className="grid grid-cols-2 bg-lightgray border-b border-border" data-id="element-37">
            <div className="p-6 text-center font-heading font-bold text-navy text-base md:text-lg" data-id="element-38">
              Without Megapack Neuro-Kid™
            </div>
            <div className="p-6 text-center font-heading font-bold text-base md:text-lg text-softred" data-id="element-39">
              The Real Cost
            </div>
          </div>
          <div className="divide-y divide-border" data-id="element-40">
            {data.map((row, i) => <div key={i} className="grid grid-cols-2 hover:bg-lightgray transition-colors" data-id="element-41">
                <div className="p-6 text-ink flex items-center justify-center text-center text-sm md:text-base font-medium" data-id="element-42">
                  {row.sin}
                </div>
                <div className="p-6 font-bold flex items-center justify-center text-center bg-softred/5 text-softred text-sm md:text-base" data-id="element-43">
                  {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-44">
          <p className="text-2xl md:text-4xl font-heading font-bold text-navy italic" data-id="element-45">
            The next 10 minutes of your child's day can be completely different.
          </p>
        </div>
      </div>
    </section>;
}